import { getEventsByAlert } from '@src/api/manualAlerts';
import { useQuery } from '@tanstack/react-query';

const useFetchAlertEvents = ({ alertId, pageSize, page }) => {
  return useQuery(
    ['manual-alert', alertId, 'events', pageSize, page],
    async () => {
      const res = await getEventsByAlert(alertId, { params: { limit: pageSize, page } });
      return res.data;
    },
    {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 1 * 60 * 1000, // 1m
      placeholderData: {
        alerts: [],
        totalEvents: {},
      },
    },
  );
};

export default useFetchAlertEvents;
